import React from 'react';
import { makeStyles, MenuItem, Select } from '@material-ui/core';
import { getUniqueKey } from '../arrayHelper';

const useStyles = makeStyles(theme => ({
    root: { '& .MuiMenu-paper': { maxHeight: 300 } },
}));

const AfitdDropDown = props => {
    const classes = useStyles();

    const { isHidden, handleChange, value, options, fullWidth, ...otherProps } = props;

    if (isHidden) {
        return null;
    } else {
        return (
            <Select MenuProps={{ className: classes.root }} fullWidth variant="outlined" color="secondary" value={value} onChange={handleChange} {...otherProps}>
                {options?.map(o => (
                    <MenuItem value={o} key={getUniqueKey()}>
                        {o}
                    </MenuItem>
                ))}
            </Select>
        );
    }
};

export default AfitdDropDown;
